
import { ScrollArea } from "@/components/ui/scroll-area";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function Privacy() {
  const navigate = useNavigate();

  return (
    <div className="container max-w-4xl py-8">
      <Button 
        variant="ghost" 
        className="mb-6" 
        onClick={() => navigate(-1)}
      >
        <ArrowLeft className="mr-2 h-4 w-4" />
        Back
      </Button>

      <div className="bg-card rounded-lg border p-6">
        <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>
        
        <ScrollArea className="h-[calc(100vh-250px)] pr-4">
          <div className="space-y-6">
            <p className="text-muted-foreground">
              This privacy policy applies to the Client Compass app (hereby referred to as "Application") for mobile devices that was created by loveable.dev (hereby referred to as "Service Provider") as a Freemium service. This service is intended for use "AS IS".
            </p>

            <h2 className="text-2xl font-semibold mt-8 mb-4">Information Collection and Use</h2>
            <p className="text-muted-foreground">
              The Application collects information when you download and use it. This information may include information such as:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
              <li>Your device's Internet Protocol address (e.g. IP address)</li>
              <li>The pages of the Application that you visit, the time and date of your visit, the time spent on those pages</li>
              <li>The time spent on the Application</li>
              <li>The operating system you use on your mobile device</li>
            </ul>
            <p className="text-muted-foreground">
              The Application does not gather precise information about the location of your mobile device.
            </p>
            <p className="text-muted-foreground">
              The Service Provider may use the information you provided to contact you from time to time to provide you with important information, required notices and marketing promotions.
            </p>
            <p className="text-muted-foreground">
              For a better experience, while using the Application, the Service Provider may require you to provide us with certain personally identifiable information, including but not limited to Name, Email, Industry. The information that the Service Provider request will be retained by them and used as described in this privacy policy.
            </p>

            <h2 className="text-2xl font-semibold mt-8 mb-4">Third Party Access</h2>
            <p className="text-muted-foreground">
              Only aggregated, anonymized data is periodically transmitted to external services to aid the Service Provider in improving the Application and their service. The Service Provider may share your information with third parties in the ways that are described in this privacy statement.
            </p>
            <p className="text-muted-foreground">
              The Service Provider may disclose User Provided and Automatically Collected Information:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
              <li>as required by law, such as to comply with a subpoena, or similar legal process;</li>
              <li>when they believe in good faith that disclosure is necessary to protect their rights, protect your safety or the safety of others, investigate fraud, or respond to a government request;</li>
              <li>with their trusted services providers who work on their behalf, do not have an independent use of the information we disclose to them, and have agreed to adhere to the rules set forth in this privacy statement.</li>
            </ul>

            <h2 className="text-2xl font-semibold mt-8 mb-4">Opt-Out Rights</h2>
            <p className="text-muted-foreground">
              You can stop all collection of information by the Application easily by uninstalling it. You may use the standard uninstall processes as may be available as part of your mobile device or via the mobile application marketplace or network.
            </p>

            <h2 className="text-2xl font-semibold mt-8 mb-4">Data Retention Policy</h2>
            <p className="text-muted-foreground">
              The Service Provider will retain User Provided data for as long as you use the Application and for a reasonable time thereafter. If you'd like them to delete User Provided Data that you have provided via the Application, please contact them at{" "}
              <a href="mailto:carynjosepher@gmail.com" className="text-primary hover:underline">
                carynjosepher@gmail.com
              </a>
              {" "}and they will respond in a reasonable time.
            </p>

            <h2 className="text-2xl font-semibold mt-8 mb-4">Children</h2>
            <p className="text-muted-foreground">
              The Service Provider does not use the Application to knowingly solicit data from or market to children under the age of 13.
            </p>
            <p className="text-muted-foreground">
              The Service Provider does not knowingly collect personally identifiable information from children. The Service Provider encourages all children to never submit any personally identifiable information through the Application and/or Services. The Service Provider encourage parents and legal guardians to monitor their children's Internet usage and to help enforce this Policy by instructing their children never to provide personally identifiable information through the Application and/or Services without their permission. If you have reason to believe that a child has provided personally identifiable information to the Service Provider through the Application and/or Services, please contact the Service Provider ({" "}
              <a href="mailto:carynjosepher@gmail.com" className="text-primary hover:underline">
                carynjosepher@gmail.com
              </a>
              ) so that they will be able to take the necessary actions. You must also be at least 16 years of age to consent to the processing of your personally identifiable information in your country (in some countries we may allow your parent or guardian to do so on your behalf).
            </p>

            <h2 className="text-2xl font-semibold mt-8 mb-4">Security</h2>
            <p className="text-muted-foreground">
              The Service Provider is concerned about safeguarding the confidentiality of your information. The Service Provider provides physical, electronic, and procedural safeguards to protect information the Service Provider processes and maintains.
            </p>

            <h2 className="text-2xl font-semibold mt-8 mb-4">Changes</h2>
            <p className="text-muted-foreground">
              This Privacy Policy may be updated from time to time for any reason. The Service Provider will notify you of any changes to the Privacy Policy by updating this page with the new Privacy Policy. You are advised to consult this Privacy Policy regularly for any changes, as continued use is deemed approval of all changes.
            </p>
            <p className="text-muted-foreground">
              This privacy policy is effective as of 2025-01-23
            </p>

            <h2 className="text-2xl font-semibold mt-8 mb-4">Your Consent</h2>
            <p className="text-muted-foreground">
              By using the Application, you are consenting to the processing of your information as set forth in this Privacy Policy now and as amended by us.
            </p>

            <h2 className="text-2xl font-semibold mt-8 mb-4">Contact Us</h2>
            <p className="text-muted-foreground">
              If you have any questions regarding privacy while using the Application, or have questions about the practices, please contact the Service Provider via email at{" "}
              <a href="mailto:carynjosepher@gmail.com" className="text-primary hover:underline">
                carynjosepher@gmail.com
              </a>
            </p>
          </div>
        </ScrollArea>
      </div>
    </div>
  );
}
